export default __webpack_public_path__ + "static/media/02_photo.42fa32d0.jpg";